import { styled } from "@mui/material";
import { CalendarMonth } from "../../index.js";
import { dateCalendarName } from "../classes.js";
const Month = styled(CalendarMonth, {
  name: dateCalendarName,
  slot: "Month",
  overridesResolver: (_, styles) => [styles.month]
})(() => ({}));
export {
  Month
};
//# sourceMappingURL=Month.js.map
